var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ajax-form',{attrs:{"action":_vm.action},on:{"submitted":_vm.trackFormEvent,"error":function($event){return _vm.$EventBus.$emit('resetCaptcha')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }